import ScrollReveal from 'scrollreveal';
import throttle from 'raf-throttle';

/**
 * Reveal elements on scroll
 */

ScrollReveal().reveal('[data-animate="up-fast"]', {}, 200);
ScrollReveal().reveal('[data-animate="up-slow"]', {
  duration: 1500,
  scale: 0.95,
});
ScrollReveal().reveal('[data-animate="up-glacial"]', {
  duration: 2250,
  scale: 0.95,
});

// Fade in from the left
ScrollReveal().reveal(
  '[data-animate="right-fast"]',
  {
    scale: 0.95,
    origin: 'left',
    distance: '5%',
  },
  200
);
ScrollReveal().reveal('[data-animate="right-slow"]', {
  origin: 'left',
  distance: '5%',
  duration: 1500,
  scale: 0.95,
});

// Fade in from the left
ScrollReveal().reveal(
  '[data-animate="left-fast"]',
  {
    origin: 'right',
    distance: '5%',
    scale: 0.95,
  },
  200
);
ScrollReveal().reveal('[data-animate="left-slow"]', {
  origin: 'right',
  distance: '5%',
  duration: 1500,
  scale: 0.95,
});

ScrollReveal().reveal(
  '[data-animate="sequence"]',
  {
    duration: 1000,
    interval: 50,
    distance: 0,
    scale: 0.8,
  },
  75
);

/*
 * Banner parallax
 */

const parallaxItems = document.querySelectorAll('[data-parallax]');
Array.from(parallaxItems).forEach(element => {
  const callback = throttle(() => {
    const bottomOffset = element.getBoundingClientRect().bottom;
    const distanceToScroll = window.pageYOffset + bottomOffset;

    if (bottomOffset >= 0) {
      const yPos = (bottomOffset / distanceToScroll) * 100;
      element.style.backgroundPosition = `50% ${yPos}%`;
    }
  });

  window.addEventListener('resize', callback);
  window.addEventListener('scroll', callback);
});
